import { useContext } from 'react';

import { BrandContext } from 'context/BrandContext';
import { isStandardVariant } from 'helpers/iconSizes';
import { ICON_SIZES } from 'lib/constants/iconSizes';

const Mushroom = ({ svgSize = ICON_SIZES.MD, className = '' }) => {
  const { theme } = useContext(BrandContext);
  const isStandardVariantIcon = isStandardVariant(svgSize);

  if (isStandardVariantIcon) {
    return (
      <svg
        width={svgSize}
        height={svgSize}
        className={className}
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M26.4933 14.6053C26.6201 15.3601 26.0227 16 25.2572 16H6.74284C5.97739 16 5.37997 15.3601 5.50675 14.6053C6.03791 11.4428 8.12456 4 16 4C23.8755 4 25.9622 11.4428 26.4933 14.6053Z"
          fill={theme.icon.fill}
        />
        <path
          d="M16.0004 3.33398C20.1914 3.3341 22.872 5.33305 24.5472 7.73633C26.2016 10.1099 26.8783 12.8741 27.1508 14.4961C27.3524 15.6991 26.3912 16.668 25.2572 16.668H19.8451C19.7753 17.1309 19.7765 17.603 19.8539 18.0674L21.14 25.7861C21.4783 27.8175 19.9122 29.6665 17.8529 29.667H14.1478C12.0884 29.6667 10.5223 27.8176 10.8607 25.7861L12.1469 18.0674C12.2242 17.6031 12.2254 17.1309 12.1556 16.668H6.74255C5.60872 16.6678 4.64736 15.699 4.849 14.4961C5.12143 12.8741 5.79818 10.1099 7.45251 7.73633C9.12781 5.33291 11.8091 3.33398 16.0004 3.33398ZM13.5013 16.668C13.5632 17.2053 13.5508 17.7503 13.4613 18.2871L12.1752 26.0049C11.972 27.2238 12.9122 28.3337 14.1478 28.334H17.8529C19.0884 28.3335 20.0287 27.2237 19.8256 26.0049L18.5394 18.2871C18.45 17.7503 18.4366 17.2053 18.4984 16.668H13.5013ZM16.0004 4.66797C12.3163 4.66797 10.016 6.3905 8.54626 8.49902C7.05585 10.6374 6.42314 13.1764 6.16443 14.7168C6.11326 15.023 6.34618 15.3338 6.74255 15.334H25.2572C25.6537 15.334 25.8874 15.023 25.8363 14.7168C25.5776 13.1764 24.9439 10.6374 23.4535 8.49902C21.9838 6.39061 19.6842 4.66808 16.0004 4.66797ZM12.7894 7.40723C13.1171 7.23989 13.5182 7.36973 13.6859 7.69727C13.8535 8.0249 13.7244 8.42694 13.3969 8.59473C12.3313 9.14012 11.5313 10.0175 10.932 11.0117C10.7419 11.3268 10.3322 11.4281 10.017 11.2383C9.70173 11.0483 9.59961 10.6385 9.78943 10.3232C10.4768 9.18291 11.4423 8.09673 12.7894 7.40723Z"
          fill={theme.icon.stroke}
        />
      </svg>
    );
  }

  return (
    <svg
      width={svgSize}
      height={svgSize}
      className={className}
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M28 4.66699C14.1249 4.66699 10.4529 16.627 9.58106 23.3492C9.33244 25.2661 10.9004 26.8337 12.8334 26.8337H43.1667C45.0997 26.8337 46.6676 25.2661 46.419 23.3492C45.5472 16.627 41.8752 4.66699 28 4.66699Z"
        fill={theme.icon.fill}
      />
      <path
        d="M28.0005 3.79102C35.2385 3.79117 39.8814 6.93267 42.7954 10.9746C45.6774 14.9722 46.8418 19.8063 47.2866 23.2354C47.6123 25.7463 45.5536 27.7079 43.1665 27.708H34.8774C34.4159 29.5904 34.3455 31.5491 34.6733 33.4619L36.6772 45.1465C37.2572 48.5317 34.649 51.624 31.2144 51.624H24.7847C21.3503 51.6238 18.7418 48.5315 19.3218 45.1465L21.3257 33.4619C21.6535 31.549 21.5841 29.5904 21.1226 27.708H12.8335C10.4464 27.708 8.3877 25.7464 8.71338 23.2354C9.15816 19.8063 10.3226 14.9722 13.2046 10.9746C16.1187 6.93256 20.7622 3.79102 28.0005 3.79102ZM22.9175 27.708C23.3484 29.695 23.3946 31.7489 23.0503 33.7578L21.0474 45.4414C20.6503 47.7576 22.4348 49.8738 24.7847 49.874H31.2144C33.5645 49.874 35.3487 47.7578 34.9517 45.4414L32.9487 33.7578C32.6044 31.7489 32.6516 29.6949 33.0825 27.708H22.9175ZM28.0005 5.54102C21.3638 5.54102 17.2332 8.37969 14.6245 11.998C11.9839 15.6608 10.8758 20.1678 10.4487 23.4609C10.2773 24.7837 11.3547 25.958 12.8335 25.958H43.1665C44.6452 25.9579 45.7227 24.7836 45.5513 23.4609C45.1242 20.1679 44.0169 15.6608 41.3765 11.998C38.7679 8.37969 34.637 5.54117 28.0005 5.54102ZM23.0054 9.37012C23.4533 9.18916 23.9639 9.40563 24.145 9.85352C24.3259 10.3014 24.1094 10.812 23.6616 10.9932C21.13 12.0166 19.4207 13.9475 18.2661 16.1553C18.0422 16.5832 17.5135 16.7481 17.0854 16.5244C16.6572 16.3005 16.4914 15.772 16.7153 15.3438C18.0033 12.8809 19.985 10.5912 23.0054 9.37012Z"
        fill={theme.icon.stroke}
      />
    </svg>
  );
};

Mushroom.propTypes = {
  className: PropTypes.string,
  svgSize: PropTypes.oneOf(Object.values(ICON_SIZES)),
};

export default Mushroom;
